import {Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from '@mui/material';
import {ExamModule} from '@cp/model';
import useAddSelectedModules from '../../hooks/users/useAddSelectedModules';

export interface CourseAddDialogProps {
  open: boolean;
  onClose: () => void;
  module: ExamModule | null;
}

export default function CourseAddDialog({open, onClose, module}: CourseAddDialogProps) {
  const {addSelectedModules, loading} = useAddSelectedModules();

  const handleAddModule = async () => {
    if (!module) return;

    try {
      // Automatically select all topics
      // const allTopics = module.topics?.map((topic) => topic.topic) || [];
      await addSelectedModules(module.id, []);
      onClose();
    } catch (error) {
      console.error('Error adding module:', error);
    }
  };

  const handleClose = () => {
    onClose();
  };

  if (!module) return null;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography component="span" variant="h6" sx={{fontWeight: 600}}>
          Add {module.name}?
        </Typography>
        <Typography component="span" variant="body2" color="text.secondary" sx={{mt: 1, display: 'block'}}>
          This will add all {module.topics?.length || 0} topics from this course to your study list.
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          You can start practicing questions from all topics in this course.
        </Typography>
      </DialogContent>

      <DialogActions sx={{px: 3, pb: 3}}>
        <Button onClick={handleClose} variant="outlined" disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleAddModule}
          variant="contained"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          {loading ? 'Adding...' : 'Add Course'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
